import { Component, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { environment } from "../../../../environments/environment";
import { QPilotService } from "../../services/qpilot.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-footer",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./footer.component.html",
  styleUrl: "./footer.component.scss",
})
export class FooterComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  currentYear = new Date().getFullYear();
  version: string = "";
  versionWithoutApi: string = "";
  termsConditionsUrl: SafeUrl;

  constructor(
    private santitizer: DomSanitizer,
    private qpilot: QPilotService,
  ) {
    this.termsConditionsUrl = santitizer.bypassSecurityTrustUrl(
      environment.termsConditionsUrl,
    );
  }

  ngOnInit(): void {
    this.qpilot
      .getApiVersion()
      .pipe(takeUntil(this.destroy$))
      .subscribe((apiversion) => {
        this.version = environment.softwareVersion + " API:" + apiversion;
        this.versionWithoutApi = environment.softwareVersion;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
